// Port of api/fuel/app/classes/filter/package/games/game/package/rank.php
export default {
	run: function(pkg, local) {
		pkg.rank = local.rank || []
		return pkg
	}
}
